import React from 'react';
import styles from '../index.module.scss';
import BasicBlock from './BasicBlock';
import GenderField from './GenderField';
import AddressField from './AddressField';

const GeneralInformation = () => {
  return (
    <div data-testid='block-general-information' className={styles.sectionWrapper}>
      <span className={styles.sectionTitle}>General Information</span>
      <div className={styles.filedsWrapper}>
        <BasicBlock />
        <GenderField />
        <AddressField />
      </div>
    </div>
  );
};

export default GeneralInformation;
